<template>
  <div id="app">
    <div class="flex_column_horizontally_center" style="width: 100vw">
      <div class="flex_column" style="width: 75rem;margin-top: 0.562rem">
        <div class="flex_row">
          <div>欢迎加入北京国商科创！</div>
          <div style="background: gray;width: 0.0625rem;height: 0.9375rem;margin-top: 0.1875rem"></div>
          <div style="padding-left:0.3125rem;cursor:pointer;">电子邮箱</div>
        </div>

        <div class="flex_row_vertical_center" style="margin-top:2.5rem;">
          <el-image src="logo.png" style="margin-left:1.875rem;width:4.375rem;height:4.375rem"></el-image>
          <div class="flex_column" style="justify-content: flex-start;margin-left:0.9375rem">
            <div style="font-size: 2rem;color: rgb(0,26,93);font-weight: bold">北京国商科创咨询有限公司</div>
            <div style="font-size: 1.125rem;color: rgb(0,26,93);width: 100%">Bei Jing Guo Shang Ke Chuang</div>
          </div>
          <el-input
              v-model="topSearchText"
              style="width: 20.375rem;height: 2.0825rem;margin-left: 18.125rem;"
              placeholder="请输入关键词"
              prefix-icon="el-icon-search">
            <template #append>
              <el-button style="width: 4.25rem;background: #478ac8;color: #fff;border-radius: 0 0.1875rem 0.1875rem 0;">
                搜索
              </el-button>
            </template>
          </el-input>
        </div>


      </div>
      <div class="flex_row_horizontally_center"
           style="width: 100vw;height:3.125rem;background: #18569c;margin-top:2.5rem;">
        <el-menu
            class="flex_row_horizontally_center"
            style="height:3.125rem;width: 75rem;font-size: 1.125rem;justify-content: space-between"
            mode="horizontal"
            background-color="#18569c"
            text-color="#fff"
            active-text-color="#ffd04b"
            @select="handleSelect"
            :router="true"
        >
          <el-menu-item style="height:3.125rem;" index="/">首页</el-menu-item>
          <el-menu-item style="height:3.125rem;" index="/article?breadcrumb_type=news">新闻中心</el-menu-item>
          <el-menu-item style="height:3.125rem;" index="/vip">会员风采</el-menu-item>
          <el-menu-item style="height:3.125rem;" index="/affiliated_agency">分支机构</el-menu-item>
          <el-menu-item style="height:3.125rem;" index="/other_association">各地协会</el-menu-item>
          <!--          <el-menu-item style="height:3.125rem;" index="/video">精彩视频</el-menu-item>-->
          <el-menu-item style="height:3.125rem;" index="/article?breadcrumb_type=information">资料</el-menu-item>
          <el-menu-item style="height:3.125rem;" index="/article?breadcrumb_type=about">关于我们</el-menu-item>
        </el-menu>
      </div>
      <div style="height: 2.1875rem"></div>
      <router-view/>


      <div class="flex_column_horizontally_center"
           style="border-top: 0.1875rem solid #dddcdc;width: 100vw;height: 14.5rem;background-color: #f5f5f5;">
        <div class="flex_row_horizontally_vertical_center" style="height: 11.875rem;text-align: left">
          <div class="flex_column_horizontally_center">
            <el-image style="width: 6.5625rem;height: 6.5625rem"
                      src="https://www.caefi.org.cn/img/qr_code_wx.png"></el-image>
            <div style="font-size: 0.875rem;line-height: 2rem;">关注微信公众号</div>
          </div>
          <div class="flex_column" style="height: 9.1875rem;margin-left: 5rem;justify-content: space-between">
            <div style="font-size: 1rem;line-height: 2.5625rem">联系方式：</div>
            <div style="font-size: 0.875rem;"><span>电话：010-51208912</span><span style="margin-left: 5.625rem">地址：中国北京市朝阳区建国门外大街乙12号</span>
            </div>
            <div style="font-size: 0.875rem;"><span>传真：010-51208914</span><span
                style="margin-left: 5.625rem">邮编：100022</span>
            </div>
            <div style="font-size: 0.875rem;">Email：member@caefi.org.cn</div>
          </div>
          <div class="flex_column" style="height: 9.1875rem;margin-left:3.125rem;justify-content: space-between">
            <div style="font-size: 1rem;line-height: 2.5625rem">友情链接：</div>
            <div class="flex_row">
              <div style="width: 7.5rem">商务部</div>
              <div>争端解决组织</div>
            </div>
            <div class="flex_row">
              <div style="width: 7.5rem">投资促进部</div>
              <div>中国国际贸易学会</div>
            </div>
            <div class="flex_row">
              <div style="width: 7.5rem">西治会</div>
              <div></div>
            </div>
          </div>
        </div>
        <div style="width: 100vw;height:0.0625rem;background: #DDDCDC"></div>
        <div class="flex_row_horizontally_vertical_center" style="margin-top: 0.75rem;">
          <div>版权所有：北京国商科创咨询有限公司</div>
          <div style="margin-left: 3.75rem">京ICP备2024069744号-1</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 1.875rem;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}
</style>
<script>
export default {

  data() {
    return {
      topSearchText: "",
    }
  },
  methods: {
    handleSelect() {
    }
  }
}
</script>